import React from 'react';

import './Separator.css';

function Separator() {
  return <div className="separator"></div>;
}

export default Separator;
